const enName = {
  required: true,
  pattern: /^[a-zA-Z][a-zA-Z0-9_-]{0,31}$/,
  message:
    '大小写英文字母、数字、「-」、「_」，只能以英文字母开头, 长度不超过 32 个字符',
}

const enNameExt = {
  required: true,
  pattern: /^[a-zA-Z][\.a-zA-Z0-9_-]{0,31}$/,
  message:
    '大小写英文字母、数字、「-」、「_」、「.」，只能以英文字母开头, 长度不超过 32 个字符',
}

const envName = {
  required: true,
  pattern: /^[a-zA-Z_][a-zA-Z0-9_]*$/,
  message: '大小写英文字母、数字、下划线，只能以英文字母或下划线开头',
}

export const IMAGE_URL_REGEX =
  /^(?:([a-zA-Z0-9.-]+(?:\:[0-9]+)?\/)?((?:[a-z0-9_\-]+\/)*[a-z0-9_\-]+)|([a-z0-9_\-]+))(?::([a-zA-Z0-9_.-]+))?$/

const imageUrl = {
  required: true,
  pattern: IMAGE_URL_REGEX,
  message: '镜像地址格式不正确',
}

const imageTag = {
  required: true,
  pattern: /^[a-z0-9]+(?:[._\-][a-z0-9]+)*$/,
  message: '小写字母、数字、下划线、中划线、点，不能以点、中划线开头',
}

const imageName = {
  required: true,
  pattern: /^[a-z0-9]+(?:[._\-][a-z0-9]+)*$/,
  message: '小写字母、数字、下划线、中划线、点，不能以点、中划线开头',
}

const relativePath = {
  required: true,
  pattern: /^(?:[^.\/][^\/]*|[^.\/][^\/]*\/([^\/]+\/)*[^\/]+)$/,
  message: '相对路径，不能以「.」、「/」开头，不能以「/」结尾',
}

const absolutePath = {
  required: true,
  pattern: /^(?:\/|\/[^\/][^\/]*|\/[^\/][^\/]*\/([^\/]+\/)*[^\/]+)$/,
  message: '绝对路径，以「/」开头，可以为根路径「/」，不能以「/」结尾',
}

const zhName = {
  required: true,
  pattern: /^[\u4e00-\u9fa5a-zA-Z0-9][\u4e00-\u9fa5a-zA-Z0-9_.\-]{0,31}$/,
  message: '中文、大小写英文字母、数字、「-」、「_」、「.」，长度不超过 32 个字符',
}

const binDiskSize = {
  required: true,
  pattern: /^\d{1,6}Gi$/,
  message: '请输入 1-999999 之间的整数，单位为 Gi',
}

const description = {
  required: false,
  pattern: /^.{0,1024}$/,
  message: '长度不超过 1024 个字符',
}

const s3Path = {
  required: true,
  pattern: /^s3:\/\/[a-zA-Z0-9-]+\/.*$/,
  message: 's3://bucket-name/path-to-dataset',
}

const cmd = {
  required: false,
  min:1,
  max: 2048,
  message: '长度不超过 2048 个字符',
}

const args = {
  required: false,
  min:1,
  max: 2048,
  message: '长度不超过 2048 个字符',
}

const domain = {
  required: true,
  pattern: /^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,6}$/,
  message: '域名，例如：example.com',
}

const password = {
  required: true,
  pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
  message: '至少包含1个大写字母，1个小写字母和1个数字。',
}

const ip = {
  required: true,
  pattern: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  message: 'IPv4 地址，例如：231.14.54.44',
}

const ipOrDomain = {
  required: true,
  pattern: /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,6})$/,
  message: 'IPv4 地址或域名'
}

const ipPort = {
  required: true,
  pattern: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?):([0-9]{1,5}|[0-5][0-9]{5}|6[0-4][0-9]{4}|65[0-4][0-9]{3}|655[0-2][0-9]{2}|6553[0-5])$/,
  message: 'IPv4 地址和端口，例如：231.14.54.44:8080',
}

const ipOrDomainWithPort = {
  required: true,
  pattern: /^(?:(?:\d{1,3}\.){3}\d{1,3}|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d{1,5})?$/,
  message: 'IPv4 地址或域名'
}

const crontab = {
  required: false,
  pattern: /^((\*|[0-5]?\d)(\/\d+)?|([0-5]?\d)(-[0-5]?\d)?)(\s+(\*|[01]?\d|2[0-3])(\/\d+)?|(\s+[01]?\d|2[0-3])(-[01]?\d)?){4}$/,
  message: 'cron 表达式',
}

const gitRepoUrl = {
  required: true,
  pattern: /(?:git@[^\s:]+:[\w-]+\/[\w.-]+|https?:\/\/[^\s\/]+\/[\w-]+\/[\w.-]+(?:\.git)?)/g,
  message: 'Git 仓库地址',
}

const validators = {
  enName,
  enNameExt,
  envName,
  imageUrl,
  relativePath,
  zhName,
  binDiskSize,
  description,
  s3Path,
  absolutePath,
  cmd,
  args,
  imageTag,
  imageName,
  domain,
  password,
  ip,
  ipPort,
  crontab,
  ipOrDomain,
  ipOrDomainWithPort,
  gitRepoUrl,
}

export default validators
